import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrainingData = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.06772 9.81323C8.27435 10.0414 8.56782 10.1715 8.87564 10.1715C9.18345 10.1715 9.47692 10.0414 9.68355 9.81323L10.2061 9.22989C10.5147 8.88853 11.0048 8.77825 11.43 8.95445C11.8551 9.13065 12.1235 9.55525 12.1002 10.0149L12.0611 10.7932C12.0437 11.1012 12.1585 11.402 12.3766 11.6201C12.5948 11.8383 12.8956 11.9531 13.2036 11.9357L13.9819 11.8966C14.4418 11.8727 14.867 12.1411 15.0431 12.5666C15.2193 12.9922 15.1083 13.4825 14.7661 13.7907L14.1877 14.3132C13.9591 14.5196 13.8286 14.8132 13.8286 15.1211C13.8286 15.4291 13.9591 15.7227 14.1877 15.9291L14.7661 16.4516C15.1083 16.7598 15.2193 17.2501 15.0431 17.6757C14.867 18.1012 14.4418 18.3696 13.9819 18.3457L13.2036 18.3066C12.8959 18.2906 12.5959 18.4058 12.3781 18.6236C12.1603 18.8414 12.0451 19.1414 12.0611 19.4491L12.1002 20.2274C12.1235 20.687 11.8551 21.1116 11.43 21.2878C11.0048 21.464 10.5147 21.3538 10.2061 21.0124L9.68355 20.4291C9.47692 20.2009 9.18345 20.0707 8.87564 20.0707C8.56782 20.0707 8.27435 20.2009 8.06772 20.4291L7.54522 21.0124C7.23653 21.3538 6.74649 21.464 6.32132 21.2878C5.89615 21.1116 5.62778 20.687 5.65105 20.2274L5.69022 19.4491C5.70568 19.1416 5.59029 18.8419 5.37258 18.6242C5.15488 18.4065 4.85521 18.2911 4.54772 18.3066L3.76939 18.3457C3.30974 18.369 2.88515 18.1006 2.70894 17.6755C2.53274 17.2503 2.64303 16.7602 2.98439 16.4516L3.56355 15.9291C3.79171 15.7224 3.92186 15.429 3.92186 15.1211C3.92186 14.8133 3.79171 14.5199 3.56355 14.3132L2.98439 13.7907C2.64303 13.482 2.53274 12.992 2.70894 12.5668C2.88515 12.1417 3.30974 11.8733 3.76939 11.8966L4.54772 11.9357C4.85535 11.9517 5.15534 11.8365 5.37316 11.6187C5.59099 11.4008 5.70621 11.1009 5.69022 10.7932L5.65105 10.0149C5.62778 9.55525 5.89615 9.13065 6.32132 8.95445C6.74649 8.77825 7.23653 8.88853 7.54522 9.22989L8.06772 9.81323Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.87522 16.6882C9.73816 16.6882 10.4377 15.9887 10.4377 15.1257C10.4377 14.2628 9.73816 13.5632 8.87522 13.5632C8.01227 13.5632 7.31272 14.2628 7.31272 15.1257C7.31272 15.9887 8.01227 16.6882 8.87522 16.6882Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5319 6.16656C17.3593 6.16656 17.2194 6.30647 17.2194 6.47906C17.2194 6.65165 17.3593 6.79156 17.5319 6.79156C17.7045 6.79156 17.8444 6.65165 17.8444 6.47906C17.8444 6.30647 17.7045 6.16656 17.5319 6.16656Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.6619 3.53989C19.8929 3.44995 20.1553 3.50506 20.3306 3.68037C20.5059 3.85567 20.561 4.11803 20.4711 4.34906L20.0544 5.42072C19.9554 5.67466 20.0327 5.96344 20.2452 6.13406L21.1411 6.85406C21.3342 7.00916 21.4175 7.26372 21.3535 7.50303C21.2894 7.74233 21.09 7.92121 20.8452 7.95906L19.7094 8.13489C19.44 8.17608 19.2285 8.38726 19.1869 8.65656L19.0111 9.79322C18.9732 10.038 18.7943 10.2374 18.555 10.3015C18.3157 10.3655 18.0612 10.2822 17.9061 10.0891L17.1861 9.19322C17.0153 8.98087 16.7269 8.90336 16.4727 9.00156L15.4011 9.41822C15.17 9.50817 14.9077 9.45306 14.7324 9.27775C14.5571 9.10244 14.5019 8.84009 14.5919 8.60906L15.0086 7.53739C15.1075 7.28345 15.0302 6.99467 14.8177 6.82406L13.9219 6.10322C13.7291 5.94824 13.646 5.69403 13.7101 5.4551C13.7741 5.21618 13.9732 5.03763 14.2177 4.99989L15.3536 4.82406C15.6229 4.78227 15.8343 4.57093 15.8761 4.30156L16.0519 3.16656C16.0893 2.92168 16.2681 2.72212 16.5073 2.65801C16.7466 2.5939 17.0012 2.67737 17.1561 2.87072L17.8769 3.76656C18.0477 3.97885 18.3363 4.05606 18.5902 3.95739L19.6619 3.53989Z",
			stroke: "#8A94A6",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTrainingData);
export { ForwardRef as ReactComponent };
